import React from 'react';

const LEGEND_LABEL_CLASSNAME = 'dbg-studio-overall-finance-overview-bullet-chart-legend-label';

const LEGEND_OPT = [
  {
    bgColor: '#4C7FE7',
    text: (<span className={LEGEND_LABEL_CLASSNAME}>YTM</span>),
    icon: null,
  },
  {
    bgColor: '#D4E8FF',
    text: (<span className={LEGEND_LABEL_CLASSNAME}>Forecast</span>),
    icon: null,
  },
  {
    bgColor: '#6A7597',
    text: (<span className={LEGEND_LABEL_CLASSNAME}>Budget</span>),
    icon: null,
  },
];

const SEGMENT_GROSS_REVENUE = '1';
const SEGMENT_NET_PROFIT = '2';

const SEGMENT_OPT = [
  {
    text: 'Gross Revenue',
    value: SEGMENT_GROSS_REVENUE,
  },
  {
    text: 'Net Profit',
    value: SEGMENT_NET_PROFIT,
  },
];

const TABLE_HEAD_MAP = {
  [SEGMENT_GROSS_REVENUE]: {
    'bo': {
      'keyName': 'bo',
      'title': ['BO', ''],
      'align': 'left',
      'width': '140px',
    },
    'studio': {
      'keyName': 'studio',
      'title': ['Studio', ''],
      'align': 'left',
      'width': '190px',
    },
    'ytm': {
      'keyName': 'ytm-gross-revenue',
      'title': ['YTM (-)', 'Gross Revenue($)'],
      'align': 'right',
      'width': '120px',
    },
    'nearest-year-budget': {
      'keyName': 'nearest-year-budget-gross-revenue',
      'title': ['-B Gross', 'Revenue($)'],
      'align': 'right',
      'width': '125px',
    },
    'completion-percent': {
      'keyName': 'completion-percent',
      'title': ['Completion%', ''],
      'align': 'left',
      'width': '200px',
    },
    'nearest-year-forecast': {
      'keyName': 'nearest-year-forecast-gross-revenue',
      'title': ['-F Gross', 'Revenue($)'],
      'align': 'right',
      'width': '125px',
    },
    'nearest-year-actual': {
      'keyName': 'nearest-year-actual-gross-revenue',
      'title': ['-A Gross', 'Revenue($)'],
      'align': 'right',
      'width': '125px',
    },
  },
  [SEGMENT_NET_PROFIT]: {
    'bo': {
      'keyName': 'bo',
      'title': ['BO', ''],
      'align': 'left',
      'width': '140px',
    },
    'studio': {
      'keyName': 'studio',
      'title': ['Studio', ''],
      'align': 'left',
      'width': '200px',
    },
    'ytm': {
      'keyName': 'ytm-net-profit',
      'title': ['YTM (-)', 'Net Profit($)'],
      'align': 'right',
      'width': '145px',
    },
    'nearest-year-budget': {
      'keyName': 'nearest-year-budget-net-profit',
      'title': ['-B Net', 'Profit($)'],
      'align': 'right',
      'width': '125px',
    },
    'completion-percent': {
      'keyName': 'completion-percent',
      'title': ['Completion%', ''],
      'align': 'left',
      'width': '200px',
    },
    'nearest-year-forecast': {
      'keyName': 'nearest-year-forecast-net-profit',
      'title': ['-F Net', 'Profit($)'],
      'align': 'right',
      'width': '125px',
    },
    'nearest-year-actual': {
      'keyName': 'nearest-year-actual-net-profit',
      'title': ['-A Net', 'Profit($)'],
      'align': 'right',
      'width': '125px',
    },
  },
};

const RECORDS_MAP: {[keyName: string]: 'grossRevenue' | 'netProfit'} = {
  [SEGMENT_GROSS_REVENUE]: 'grossRevenue',
  [SEGMENT_NET_PROFIT]: 'netProfit',
};

const DOWNLOAD_LOG_MAP: any = {
  '1_revenue': 'STUDIO_OVERALL_FINANCE_OVERVIEW_GROSS_REVENUE_CSV_SUBMIT',
  '2_revenue': 'STUDIO_OVERALL_FINANCE_OVERVIEW_GROSS_REVENUE_EXCEL_SUBMIT',
  '1_profit': 'STUDIO_OVERALL_FINANCE_OVERVIEW_NET_PROFIT_CSV_SUBMIT',
  '2_profit': 'STUDIO_OVERALL_FINANCE_OVERVIEW_NET_PROFIT_EXCEL_SUBMIT',
};

const COMMON_DEFAULT_VALUE = {
  'grossRevenue': null,
  'netProfit': null,
};

// 固定排序的bo
const FIXED_BO_ORDER_MAP = [
  'amplifier',
  'astra',
  'nexus',
  'saturn',
  'solar',
];

export {
  SEGMENT_OPT,
  SEGMENT_GROSS_REVENUE,
  SEGMENT_NET_PROFIT,
  LEGEND_OPT,
  TABLE_HEAD_MAP,
  RECORDS_MAP,
  DOWNLOAD_LOG_MAP,
  COMMON_DEFAULT_VALUE,
  FIXED_BO_ORDER_MAP,
}
